import INFTCollections from '../../models/INFTCollections'
import NovaXCard from '../../nftFormats/NovaX/Card/NovaXCard'
import NovaXDetail from '../../nftFormats/NovaX/Detail/NovaXDetail'
import NovaXActivtyDetail from '../../nftFormats/NovaX/Activity/NovaXActivtyDetail'
import NovaxLogo from '../../../../assets/nft-logo/Novax.jpg'
import GeneralCard from '../../nftFormats/Generals/Card/GeneralCard'
import GeneralDetail from '../../nftFormats/Generals/Detail/GeneralDetail'
import GeneralActivityDetail from '../../nftFormats/Generals/Activity/GeneralActivityDetail'

export const NovaXData: INFTCollections[] = [
  {
    id: 'Novax',
    tokenAddress: '0x0c3b29321611736341609022c23e981ac56e7f96',
    name: 'NovaX',
    cardFormat: NovaXCard,
    detailFormat: NovaXDetail,
    activityFormat: NovaXActivtyDetail,
    category: 2,
    creatorAddress: '0x3C63E0d1d300b80D01c3c54dBEDe6bc00D273891',
    logo: NovaxLogo,
    twitter: 'novax_game',
    telegram: 'https://t.me/novaxchat',
    discord: 'https://discord.com/invite/2XKSphs5x9'
  },
  {
    id: 'NovaxLoots',
    tokenAddress: '0x9ab7f0203cb23f7a6a33eD7AFA518B4a34e5E7C7',
    name: 'NovaX Loots',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 2,
    creatorAddress: '0x3C63E0d1d300b80D01c3c54dBEDe6bc00D273891',
    logo: NovaxLogo,
    twitter: 'novax_game',
    telegram: 'https://t.me/novaxchat',
    discord: 'https://discord.com/invite/2XKSphs5x9'
  },
  {
    id: 'NovaxTroops',
    tokenAddress: '0x7C347AF74c8DfAf629E4E4D3343d6E6A6ecACe80',
    name: 'NovaX Troops',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 2,
    creatorAddress: '0x3C63E0d1d300b80D01c3c54dBEDe6bc00D273891',
    logo: NovaxLogo,
    twitter: 'novax_game',
    telegram: 'https://t.me/novaxchat',
    discord: 'https://discord.com/invite/2XKSphs5x9'
  }
]

export const NovaXCategoryData = {
  [NovaXData[0].tokenAddress.toLowerCase()]: NovaXData[0].category,
  [NovaXData[1].tokenAddress.toLowerCase()]: NovaXData[1].category,
  [NovaXData[2].tokenAddress.toLowerCase()]: NovaXData[2].category
}
